var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("period-filter", {
    ref: "periodFilter",
    attrs: {
      loadingList: _vm.isLoading,
      dropdownOptions: _vm.dropdownOptions,
      selectedPeriod: _vm.selectedPeriod,
    },
    on: { dateFiltersChanged: _vm.search },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }